import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center gap-2" };
import _ from "lodash";
import i18n from "@/localization/localization";
import moment from "moment";
import TransactionsList from "@/components/uikit/platformComponents/transactions/TransactionsList.vue";
import { computed, onMounted, ref, watch } from "vue";
import { iconLink } from "@/help/transactionHelper.js";
import { useStore } from "vuex";
import { useUser } from "@/composables/useAuth";
import { useRoute } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionsHistory',
    setup(__props) {
        const loading = ref(false);
        const t = (key) => i18n.global.t(key);
        const store = useStore();
        const user = useUser();
        const route = useRoute();
        const projectId = ref(route.params.id || "");
        const addressEth = ref(null);
        const userIRI = ref("");
        const userIdUrl = ref("");
        const transactions = ref([]);
        const currentCapital = ref({});
        const ethAddresses = computed(() => store.getters.ethAddresses);
        const updateInfoFlag = computed(() => store.getters["capitals/updateInfoFlag"]);
        watch(updateInfoFlag, async () => {
            await getTransactions();
        });
        onMounted(async () => {
            userIRI.value = `/api/users/${user?.id}`;
            userIdUrl.value = `/api/users/${user?.id}`;
            loading.value = true;
            currentCapital.value = await store.dispatch("capitals/getAuCapitals", projectId.value);
            await getTransactions();
            loading.value = false;
        });
        const getTransactions = async () => {
            if (!ethAddresses.value?.[0]?.verifiedAt) {
                return;
            }
            let params = {
                page: 1,
                itemsPerPage: 3,
                auCapitalId: projectId.value,
                sort: "desc",
                methodName: "vote,investing,investing_nft,capital_refund"
            };
            let resp = await store.dispatch("getTransactionsHistory", params);
            let transfer = resp.data;
            transactions.value = [{ date: "", transactions: [] }];
            if (transfer.length === 0) {
                return;
            }
            transfer.forEach((transaction) => {
                ethAddresses.value.forEach((eth) => {
                    if (_.toLower(eth.value) === _.toLower(transaction?.addressFrom)) {
                        addressEth.value = transaction?.addressFrom;
                    }
                    if (userIdUrl.value == _.toLower(transaction?.fromUser)) {
                        addressEth.value = transaction?.addressFrom;
                        transaction.isOwnerTransaction = true;
                    }
                    else if (_.toLower(eth.value) === _.toLower(transaction?.addressTo)) {
                        addressEth.value = transaction?.addressTo;
                    }
                    else {
                        addressEth.value = transaction?.addressFrom;
                    }
                });
                transactions.value[0].transactions.push({
                    icon: iconLink(transaction),
                    name: _.isNil(addressEth.value)
                        ? t("transactions.unspecified")
                        : addressEth.value.slice(0, 4) + "..." + addressEth.value.slice(-4),
                    addressFrom: _.get(transaction, "addressFrom", "-"),
                    addressTo: _.get(transaction, "addressTo", "-"),
                    addressEth: addressEth.value,
                    amount: _.get(transaction, "amount", null),
                    isConfirmed: _.get(transaction, "isConfirmed", false),
                    cardType: moment(transaction.createdAt).format("DD.MM.YYYY HH:mm:ss"),
                    isRefill: getSign(transaction?.methodName, transaction?.addressTo),
                    type: _.get(transaction, "methodName", "transfer"),
                    decimals: _.get(transaction, "auToken.decimals", 2),
                    indent: _.get(transaction, "auToken.indent", 2),
                    mnemonic: _.get(transaction, "auToken.mnemonicEng", "-"),
                    createdAt: _.get(transaction, "createdAt", "-"),
                    hash: _.get(transaction, "hash", "-"),
                    isOwnerTransaction: _.get(transaction, "isOwnerTransaction", transaction?.isOwnerTransaction),
                    projectId: projectId.value,
                    projectName: currentCapital.value?.tokenBase?.nameEng,
                    isVoting: transaction?.auCapital?.projectType === "voting"
                });
            });
        };
        const getSign = (methodName, addressTo) => {
            if (methodName === "Payment for open sale tokens" ||
                methodName === "transfers_for_open_sale_tokens") {
                return true;
            }
            return (_.toLower(currentCapital.value?.smartContract?.ethAddress?.value) ==
                _.toLower(addressTo));
        };
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createBlock(_component_UContent, {
                padding: "15px",
                "header-align": "space-between",
                "header-padding": "0px 0px 15px 0px",
                "has-title-delimiter": false
            }, {
                "header-left": _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_UIcon, { icon: "/img/capital/lines.svg" }),
                        _cache[0] || (_cache[0] = _createElementVNode("span", null, "Participation history", -1))
                    ])
                ]),
                "header-right": _withCtx(() => [
                    _createVNode(_component_RouterLink, {
                        to: '/transactions?type=all',
                        class: "link ml-2",
                        target: "_blank"
                    }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" All participations ", -1)
                            ]))]),
                        _: 1
                    })
                ]),
                content: _withCtx(() => [
                    (loading.value)
                        ? (_openBlock(), _createBlock(_component_UProgressBar, {
                            key: 0,
                            green: "",
                            "is-loader": ""
                        }))
                        : (_openBlock(), _createBlock(TransactionsList, {
                            key: 1,
                            transactions: transactions.value,
                            "is-investment-history": true
                        }, null, 8, ["transactions"]))
                ]),
                _: 1
            }));
        };
    }
});
